import React from 'react';
import styled from 'styled-components';
import NavList from '../common/NavList';
import MasterInfo from '@template/MasterInfo';
import UserInfoSec from '@template/User/UserInfo/UserInfoSec';
import MiniNavBar from '../common/MiniNavBar';
import { AsideBox } from '@pages/MainHome/common/commonStyle';
import { MAIN_HOME_SEC_TYPE } from '@typings/setting/MainHomeSecType';
import { useDocument } from '@nandorojo/swr-firestore';
import DdayWidget from '@template/Widget/DdayWidget';
import { CollectionPath, ImainhomeDoc } from '@typings/collections.enum';
import DailyTodoList from '@template/DailyTodo/DailyTodoList';

const NavContainer = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 12px;
  height: fit-content;
  min-height: 100vh;
`;

const Component = styled.div`
  flex-shrink: 0;
`;

type Props = {
  showNavBar?: boolean;
};
function BlogNav({ showNavBar = true }: Props) {
  const MAIN_HOME_SEC_COMPONENT_MAP = {
    [MAIN_HOME_SEC_TYPE.MENU]: (
      <AsideBox style={{ padding: 0 }}>
        <NavList />
      </AsideBox>
    ),
    [MAIN_HOME_SEC_TYPE.USERLOGIN]: (
      <AsideBox style={{ padding: 0 }}>
        <UserInfoSec style={{ height: 'auto', padding: '12px' }} />
      </AsideBox>
    ),
    [MAIN_HOME_SEC_TYPE.DDAYWIDGHET]: (
      <AsideBox style={{ padding: 0 }}>
        <DdayWidget />
      </AsideBox>
    ),
    [MAIN_HOME_SEC_TYPE.MASTERINFO]: (
      <AsideBox style={{ padding: 0, overflow: 'hidden' }}>
        <MasterInfo />
      </AsideBox>
    ),
    [MAIN_HOME_SEC_TYPE.DAILYTODO]: (
      <AsideBox style={{ padding: 0, overflow: 'hidden' }}>
        <DailyTodoList />
      </AsideBox>
    ),
  };
  const { data, set } = useDocument<any>(
    `${CollectionPath.MAINHOME}/${ImainhomeDoc.MAINMENU}`,
    { listen: true },
  );

  return (
    <>
      <NavContainer>
        {showNavBar && (
          <AsideBox style={{ padding: 0 }}>
            <MiniNavBar
              style={{
                position: 'sticky',
                top: '12px',
                zIndex: 2,
              }}
            />
          </AsideBox>
        )}

        {data && data.list && data.list.length >= 1 ? (
          data.list
            .filter((item) => item.isShow)
            .map((item, i) => {
              const _Component = MAIN_HOME_SEC_COMPONENT_MAP[item.key];
              const isUserLogin = item.key === MAIN_HOME_SEC_TYPE.USERLOGIN;
              if (_Component) {
                return (
                  <Component
                    key={item.key}
                    style={
                      isUserLogin ? { overflow: 'visible', zIndex: 1 } : {}
                    }
                  >
                    {_Component}
                  </Component>
                );
              }
              return null;
            })
        ) : (
          <NavList style={{ padding: '16px 0' }} />
        )}
      </NavContainer>
    </>
  );
}

export default BlogNav;
